import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CredentialsService } from '../authentication/credentials.service';
import { LoginContext } from 'src/services/login-context.model';

@Injectable({
  providedIn: 'root'
})
export class HttpInterceptorService implements HttpInterceptor {
  profile: LoginContext | null;

  constructor(private credentialService: CredentialsService) {
    if (this.credentialService.isAuthenticated()){
      this.profile = this.credentialService.credentials;
    }
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.credentialService.isAuthenticated()){
      this.profile = this.credentialService.credentials;
    }
    const token = this.profile == null ? null : this.profile.token;

    if (token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        }
      });
    }
    return next.handle(request);
  }

}
